function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 21.1,
  y: 30.9,
  width: 26.5,
  height: 3.2
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 20.9,
  y: 78.4,
  width: 12.7,
  height: 3.2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 20.9,
  y: 62.6,
  width: 12.5,
  height: 3.1
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 47.6,
  width: 18.9,
  height: 2.8
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M79.3,45.2l0-26.4l-16.9-18H5.8v97.7h56.4c1.2,0.2,2.5,0.3,3.8,0.3c15.7,0,28.5-12.8,28.5-28.5 C94.4,61.2,91.1,52.3,79.3,45.2z M63.5,4.8l13.7,14.7H63.5V4.8z M8.5,96V3.6h53.4v17.6h15.6v23.2c-3.6-1.6-7.5-2.5-11.6-2.5 c-15.7,0-28.5,12.8-28.5,28.5c0,9.2,3.3,19,16.2,25.6H8.5z M65.9,96.9c-14.6,0-26.5-11.9-26.5-26.5c0-14.6,11.9-26.5,26.5-26.5 s26.5,11.9,26.5,26.5C92.4,85,80.5,96.9,65.9,96.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M81.7,64.5h-2.3L77.9,60c-0.7-2.4-3-3.9-5.4-3.9H59.4c-2.5,0-4.7,1.6-5.4,3.9l-1.5,4.6h-2.3c-1,0-1.8,0.8-1.8,1.8v0.3 c0,1,0.8,1.8,1.8,1.8h0.7c-0.4,1.6-0.6,4.1-0.6,5.8v8.7c0,1,0.8,1.8,1.8,1.8h0.8c1,0,1.8-0.8,1.8-1.8v-2.7h22.5v2.7 c0,1,0.8,1.8,1.8,1.8h0.8c1,0,1.8-0.8,1.8-1.8v-8.6c0-1.7-0.2-4.1-0.6-5.8h0.7c1,0,1.8-0.8,1.8-1.8v-0.3 C83.4,65.4,82.6,64.5,81.7,64.5z M56.3,58.9c0.2-0.7,0.9-1.2,1.6-1.2H74c0.7,0,1.4,0.4,1.6,1.2l2.4,7.5H53.8L56.3,58.9z M58.3,75.6 H54c-0.7,0-1.3-0.6-1.3-1.3v-2c0-0.8,0.7-1.4,1.5-1.3l4,0.6c0.5,0.1,1,0.5,1,1l0.3,1.4C59.7,74.7,59.1,75.6,58.3,75.6z M79.1,74.2 c0,0.7-0.6,1.3-1.3,1.3h-4.3c-0.8,0-1.5-0.8-1.3-1.6l0.3-1.4c0.1-0.5,0.5-1,1-1l4-0.6c0.8-0.1,1.5,0.5,1.5,1.3"
});

var SvgVehicleContract = function SvgVehicleContract(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicleContract, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle-contract.f00af4fd.svg";
export { ForwardRef as ReactComponent };